import React, { useEffect, useState } from "react";
import { fieldsTimeOutValue } from "components/Field/index";
import PropTypes from "prop-types";
import { uniqueId } from "utils";

const FirstNameField = ({
  firstName,
  setFirstName,
  firstNameError,
  setFirstNameError,
  labelText,
}) => {
  const id = uniqueId();

  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (!initialLoad) {
        if (firstName === "") {
          setFirstNameError(true);
        } else {
          setFirstNameError(false);
        }
      }
    }, fieldsTimeOutValue);
    return () => clearTimeout(timeOutId);
  }, [firstName]);

  const handleChange = (e) => {
    setFirstName(e.target.value);
    if (initialLoad) {
      setInitialLoad(false);
    }
  };

  return (
    <label
      htmlFor={`${id}_form_field-firstname`}
      className="form__field__firstname"
    >
      <b>{labelText || "First Name"}</b>
      <input
        type="text"
        id={`${id}_form_field-firstname`}
        value={firstName}
        onChange={handleChange}
        className={firstNameError && "input__error"}
      />
    </label>
  );
};

export default FirstNameField;

FirstNameField.propTypes = {
  firstName: PropTypes.string.isRequired,
  setFirstName: PropTypes.func.isRequired,
  firstNameError: PropTypes.bool.isRequired,
  setFirstNameError: PropTypes.func.isRequired,
  labelText: PropTypes.string,
};
